import React, { FC, useCallback, useMemo, ComponentType } from "react";
import { getOrder } from "../build-order";
import { ICart } from "constants/cart";
import type { IScope } from "reducers/scope";

interface Props {
    cart: ICart;
    scope: IScope;
    onFetch: (filters: { [key: string]: string | number }) => void;
    [key: string]: any;
}

export const withFilteredProductsFetch = (Component: ComponentType<Props> | FC<Props>) =>
    function WithFilteredProductsFetch(props: Props) {
        const { scope, cart, onFetch } = props;
        const useOrderWarehouse = useMemo(
            () => scope?.brand?.hasPreference("set_warehouse_for_linesheets"),
            [scope?.brand]
        );

        const handleFetchProducts = useCallback(
            (filters) => {
                if (useOrderWarehouse) {
                    const order = getOrder(cart);
                    filters.__warehouses = order.selected_warehouse ? [order.selected_warehouse] : undefined;
                }
                onFetch({ ...filters });
            },
            [useOrderWarehouse, cart, onFetch]
        );

        return <Component {...props} onFetch={handleFetchProducts} />;
    };
